// Libraries
import React from "react";
import { useObserver } from "mobx-react-lite";

// Custom
import { IEGridCategoryModel } from "../../IEmodels";
import { CommercialViewModel } from "../../Commercial.ViewModel";
import { PackagesViewModel } from "../../PackagesViewModel";
import { formatCurrencyForGrid, formatCurrencyNoSign, formatVariationNumber } from "Utils/Format";

// Styling & Images
import { ToggleButton } from "../VariationGrid.Styles";
import { VariationGridModel } from "../../IEmodels/Variation/VariationGridModel";
import { formatCreditDebitClass, formatCreditDebitReverseClass } from "Utils/Utils";
import { VariationTypeEnum } from "Views/Variation/Form/VariationModel";

interface ITableProps {
    itemModel: VariationGridModel;
    rowType: string;
    rowIndex: number;
    iEId: string;
    rowEnable(index: number): void;
    currentActiveVarIndex: number;
    variationType: VariationTypeEnum;
}

export const Variation: React.FunctionComponent<ITableProps> = (props) => {
    const { itemModel, rowType, rowIndex, rowEnable, currentActiveVarIndex, variationType } = props;
    const packagesViewModel = PackagesViewModel.Instance;
    const commercialViewModel = CommercialViewModel.Instance;

    const formatDebit = (val: number) => {
        return commercialViewModel.formatDebit(val);
    };

    const handleName = () => {
        return `${formatVariationNumber(itemModel.variationNumber, variationType)} - ${itemModel.description}`;
    };

    return useObserver(() => (
        <>
            <li className={rowType} key={"cat_" + rowIndex}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span style={{ color: `${currentActiveVarIndex === rowIndex ? "#0095DA" : ""}`, paddingLeft: "5px" }} className="ellipsis-2-lines" title={handleName()}>
                        {handleName()}
                    </span>
                    {currentActiveVarIndex === rowIndex ? (
                        <ToggleButton>
                            <span
                                className={"open"}
                                onClick={() => {
                                    rowEnable(-1);
                                }}
                            >
                                &minus;
                            </span>
                        </ToggleButton>
                    ) : (
                        <ToggleButton>
                            <span
                                className={"opcloseen"}
                                onClick={() => {
                                    rowEnable(rowIndex);
                                }}
                            >
                                &#43;
                            </span>
                        </ToggleButton>
                    )}
                </div>
                <div className="right">{formatCurrencyForGrid(formatCurrencyNoSign(itemModel.income))}</div>
                <div className="right">{formatCurrencyForGrid(formatCurrencyNoSign(itemModel.estimateCost))}</div>
                <div className="right">{itemModel.margin}</div>
                <div className={"right" + formatDebit(itemModel.committedCost)}>{formatCurrencyForGrid(formatCurrencyNoSign(itemModel.committedCost))}</div>
                <div className="right">{formatCurrencyForGrid(formatCurrencyNoSign(itemModel.futureSpend))}</div>
                <div className="right">{formatCurrencyForGrid(formatCurrencyNoSign(itemModel.totalExpectedSpend))}</div>
                <div className={"right" + formatCreditDebitClass(itemModel.variance)}>{formatCurrencyForGrid(formatCurrencyNoSign(itemModel.variance))}</div>
                <div className={"right" + formatCreditDebitReverseClass(itemModel.roValue)}>{formatCurrencyForGrid(formatCurrencyNoSign(itemModel.roValue))}</div>
                <div className="right" style={{ display: "flex", alignItems: "center", justifyContent: "space-around" }}></div>
            </li>
        </>
    ));
};
